'use client';
import {DisclosureGroup as RACDisclosureGroup, DisclosureGroupProps} from 'react-aria-components';
import './DisclosureGroup.css';

export function DisclosureGroup(props: DisclosureGroupProps) {
  return <RACDisclosureGroup {...props} />;
}
